import axios from "axios"
import React, { useState, useEffect } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import UpdatePickupAddress from "./UpdatePickupAddress";
import { Navigate, useNavigate } from "react-router-dom";



const SelectPickupPopup = ({ onClose, setSelectedData,title,setRefresh,refresh }) => {
    const [Pickup, setPickUp] = useState(null); // Selected Pickup Address
    const [refresh1, setRefresh1] = useState(false);
    const [isModalOpen1, setIsModalOpen1] = useState(false); // Pickup Address Modal
    const [pickupAddress, setPickUpAddress] = useState([]); // Pickup Address List
    const [showBulkShipModal, setShowBulkShipModal] = useState(false); // Local modal state
    const [formData, setFormData] = useState({
        contactName: "",
        email: "",
        phoneNumber: "",
        address: "",
        pinCode: "",
        city: "",
        state: "",
    });
    const navigate = useNavigate()
    // console.log(setSelectedData)
    const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    useEffect(() => {
        const fetchPickupAddresses = async () => {
            try {
                const token = document.cookie.split("=")[1]; // Extract token
                const response = await axios.get(
                    `${REACT_APP_BACKEND_URL}/order/pickupAddress`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
                // console.log("Fetched Pickup Addresses:", response.data.data);
                setPickUpAddress(response.data.data || []);
            } catch (error) {
                console.error("Error fetching pickup addresses:", error);
            }
        };
        fetchPickupAddresses();
    }, [refresh1]);

    // Handle Pickup Address Selection
    const handlePickupChange = (selectedOption) => {
        if (selectedOption?.value !== "no_address") {
            const selectedPickup = pickupAddress.find(
                (address) => address._id === selectedOption.value
            );
            setPickUp(selectedPickup || null);

            if (selectedPickup) {
                setFormData({
                    contactName: selectedPickup.pickupAddress?.contactName || "",
                    email: selectedPickup.pickupAddress?.email || "",
                    phoneNumber: selectedPickup.pickupAddress?.phoneNumber || "",
                    address: selectedPickup.pickupAddress?.address || "",
                    pinCode: selectedPickup.pickupAddress?.pinCode || "",
                    city: selectedPickup.pickupAddress?.city || "",
                    state: selectedPickup.pickupAddress?.state || "",
                });
            }
        } else {
            setPickUp(null);
            setFormData({
                contactName: "",
                email: "",
                phoneNumber: "",
                address: "",
                pinCode: "",
                city: "",
                state: "",
            });
        }
    };

    // Prepare Pickup Address Options
    const pickupOptions =
        pickupAddress.length > 0
            ? pickupAddress.map((address) => ({
                value: address._id,
                label: address.pickupAddress?.contactName || "Unnamed Contact",
            }))
            : [{ value: "no_address", label: "No pickup addresses available" }];

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // setPickupAddress(formData);

            const token = Cookies.get("session");
            if (!token) {
                console.error("No authentication token found.");
                return;
            }
            console.log(formData)

            const response = await axios.post(
                `${REACT_APP_BACKEND_URL}/bulk/updatePickup`,
                { formData, setSelectedData },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log(response)

            if (response.status === 200 || response.status === 201) {
                console.log("Pickup address saved successfully:", response.data);
                toast.success("Pickup address updated successfully!");
                if(title === "Bulk Ship") {
                    navigate("/dashboard/order/bulkSelection", { state: { selectedOrders: setSelectedData, wh: formData } })
                }else{
                    setRefresh(!refresh)
                    navigate("/dashboard/order")
                }
                setFormData({
                    contactName: "",
                    email: "",
                    phoneNumber: "",
                    address: "",
                    pinCode: "",
                    city: "",
                    state: "",
                });
                onClose(); // Close modal after successful save
            } else {
                console.error("Unexpected response:", response);
            }
        } catch (error) {
            toast.error("Error saving pickup address. Please try again.");
            console.error("Error saving pickup address:", error.response?.data || error.message);
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-[700px] relative">
                <h2 className="font-[600] text-[12px] sm:text-[14px] mb-2 text-gray-700">
                    Order Pickup Info
                </h2>
                <Select
                    options={pickupOptions}
                    onChange={handlePickupChange}
                    className="w-full min-h-[30px] rounded-lg font-[600] text-gray-500 text-[10px] sm:text-[12px]"
                />
                <button
                    onClick={() => setShowBulkShipModal(true)}
                    className="text-[#0CBB7D] mt-2 text-[10px] sm:text-[12px] w-full sm:w-auto text-left sm:text-right"
                >
                    + Add new pickup address
                </button>

                {/* Selected Pickup Address Display */}
                {Pickup && (
                    <div className="mt-2 text-gray-500 text-[10px] sm:text-[12px] bg-gray-100 p-2 rounded-lg">
                        <p>
                            <strong>Contact Name:</strong>{" "}
                            {Pickup.pickupAddress?.contactName}
                        </p>
                        <p>
                            <strong>Address:</strong> {Pickup.pickupAddress?.address},{" "}
                            {Pickup.pickupAddress?.city}, {Pickup.pickupAddress?.pinCode}
                        </p>
                    </div>
                )}
                <div className="col-span-2 text-right flex gap-2 mt-2 justify-end">
                    <button
                        type="button"
                        className="bg-gray-200 text-[10px] sm:text-[12px] font-[600] text-gray-500 px-3 py-2 rounded-lg"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={handleSubmit}
                        className="bg-[#0CBB7D] text-[10px] sm:text-[12px] font-[600] text-white px-3 py-2 rounded-lg"
                    >
                        Save
                    </button>
                    
                </div>
            </div>
            {showBulkShipModal && (
                <UpdatePickupAddress onClose={() => setShowBulkShipModal(false)} setRefresh={setRefresh}
                    setPickupAddress={(newAddress) =>
                        setPickUpAddress((prev) => [...prev, newAddress])
                    } />
            )}
        </div>
    )
}

export default SelectPickupPopup